import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id A26AE0CE-1223-4A40-B7B6-E4FDCC5AE820
 * name page-previous-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-previous-outline.svg
 * tags
 */
export const PagePreviousOutlineIcon = createSvgIcon(<><path d="M2,3H19A2,2 0 0,1 21,5V9H19V5H2V19H19V15H21V19A2,2 0 0,1 19,21H2A2,2 0 0,1 0,19V5A2,2 0 0,1 2,3M17,15V13H24V11H17V9L13,12L17,15M4,13H11V11H4V13M4,9H11V7H4V9M4,17H8V15H4V17Z" /></>, 'PagePreviousOutlineIcon');
export default PagePreviousOutlineIcon